import { http } from "@/http/axios.js";

// 联营配置列表
export function getJointTplPageAPI(params) {
  return http({
    url: "/admin/store/joint/tpl/page",
    method: "get",
    params,
  });
}

// 新增模板
export function addJointTplAPI(data) {
  return http({
    url: "/admin/store/joint/tpl/add",
    method: "post",
    data,
  });
}

// 编辑模板
export function editJointTplAPI(data) {
  return http({
    url: "/admin/store/joint/tpl/edit",
    method: "post",
    data,
  });
}

// 设置默认模板
export function editJointTplDefaultAPI(data) {
  return http({
    url: "/admin/store/joint/tpl/default/edit",
    method: "post",
    data,
  });
}

// 联营配置模板详情
export function getJointTplDetailAPI(params) {
  return http({
    url: "/admin/store/joint/tpl/detail",
    method: "get",
    params,
  });
}

